import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

// Logic
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import { UncontrolledInput } from '@/components/UncontrolledForm'
import useVendor from '@/features/vendors/useVendor'
import { hideCreateTempVendorModal, selectCreateTempVendorModal } from '@/stores/offers/offersSlice'

const CreateTempVendorModal = () => {
  const { show } = useSelector(selectCreateTempVendorModal)

  const [email, setEmail] = useState('')

  const dispatch = useDispatch()
  const { useRequestCreateTempVendor } = useVendor()
  const requestCreateTempVendor = useRequestCreateTempVendor()
  const closeModal = () => {
    dispatch(hideCreateTempVendorModal())
  }

  const onSubmit = async () => {
    try {
      dispatch(showLoadingOverlay())
      await requestCreateTempVendor.mutateAsync({ email })
      closeModal()
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Temp. Vendor</ModalHeader>

        <ModalCloseButton />
        <ModalBody>
          <Flex gap={3} direction={'column'}>
            <UncontrolledInput label="Email" isRow onChange={setEmail} value={email} />
          </Flex>
        </ModalBody>

        <ModalFooter>
          <HStack>
            <Button colorScheme="green" onClick={onSubmit}>
              Confirm
            </Button>

            <Button colorScheme="gray" onClick={closeModal}>
              Close
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CreateTempVendorModal
